/* eslint-disable */
import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DateTime } from 'luxon';
import { MONTHS } from '../enums/Months.enum';

@Pipe({
  name: 'localizedDate',
  pure: false,
  standalone: true,
})
export class DatePipe implements PipeTransform {
  public months: MONTHS[] = Object.values(MONTHS);

  constructor(private translate: TranslateService) {}

  transform(value: any, short = false, showTime = false, germanTime = false, localTime = false): string {
    if (!value || (!(value instanceof Date) && typeof value !== 'string')) {
      return value;
    }

    const date: Date = typeof value === 'string' ? new Date(value) : value;

    if (short) {
      return String(this.translate.instant('default.months.' + this.months[date.getMonth()])) + ' ' + String(date.getFullYear());
    }

    if (showTime && germanTime) {
      return Intl.DateTimeFormat('de-DE', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        hour12: false,
        timeZone: 'Europe/Berlin',
      }).format(date);
    }

    if (showTime) {
      return DateTime.fromJSDate(date)
        .setZone(localTime ? 'local' : 'utc')
        .toFormat('dd.MM.yyyy HH:mm');
    }

    return DateTime.fromISO(date.toISOString()).setZone('utc').toFormat('dd.MM.yyyy');
  }
}
